import { render, staticRenderFns } from "./extendedAttrs.vue?vue&type=template&id=79984b63&scoped=true"
import script from "./extendedAttrs.vue?vue&type=script&lang=js"
export * from "./extendedAttrs.vue?vue&type=script&lang=js"
import style0 from "./extendedAttrs.vue?vue&type=style&index=0&id=79984b63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79984b63",
  null
  
)

export default component.exports